/* External */
import { all, call, spawn } from 'redux-saga/effects';

/* Sagas */
import contentSagas from './contents/sagas';
import pageSagas from './pages/sagas';
import seasonSagas from './seasons/sagas';
import carouselSagas from './carousels/sagas';
import showSagas from './shows/sagas';
import channelSagas from './channels/sagas';
import utilsSagas from './utils/sagas';
import profilesSagas from './profiles/sagas';

const sagas = [
  ...contentSagas,
  ...pageSagas,
  ...seasonSagas,
  ...carouselSagas,
  ...showSagas,
  ...channelSagas,
  ...utilsSagas,
  profilesSagas,
];

const allSagas = sagas.map((saga) => spawn(function* spawnedGenerator() {
  while (true) {
    try {
      yield call(saga);
      break;
    } catch (error) {
      console.error(error);
    }
  }
}));

export default function* rootSaga() {
  yield all(allSagas);
}
